"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function Diamond16Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.82846 8L7.00006 11.1716L7.00006 8H3.82846ZM12.1716 8L9.00006 11.1715V8H12.1716ZM10.1713 3L8.00006 5.48141L5.82883 3H10.1713ZM11.9423 4.01317L10.2038 6H13.1013L11.9423 4.01317ZM5.79629 6H3.0704L4.24917 4.23185L5.79629 6ZM0.181933 6.72715L4.00003 1H12.5L15.8447 6.73365C15.9362 6.8906 15.9105 7.08955 15.782 7.21804L8.28288 14.7172C8.12667 14.8734 7.8734 14.8734 7.71719 14.7172L0.23191 7.23188C0.0970843 7.09705 0.0761668 6.8858 0.181933 6.72715Z", fill: "#597EFF" }));
}
function Diamond16(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(Diamond16Svg, Object.assign({}, svgProps)));
}
exports.default = Diamond16;
//# sourceMappingURL=Diamond16.js.map